// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
import uuid from 'uuid/v4';

/**
 * Creates the chat channelID for use with ConvoAI/assistance-service API.
 */
export const buildChannelId: () => string = () => {
	// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
	return uuid();
};
